import $ from 'jquery'

export const truncate = (str, maxLength) => {
  return str.split(' ').splice(0, maxLength).join(' ')
}

export const priceFormatNumber = price => {
  let decimals = false
  let decPoint = false
  let thousandsPoint = false

  if (price == null || !isFinite(price)) throw new TypeError('price is not valid')

  if (!decimals) {
    const len = price.toString().split('.').length
    decimals = len > 1 ? len : 0
  }

  if (!decPoint) decPoint = '.'

  if (!thousandsPoint) thousandsPoint = ','

  price = parseFloat(price).toFixed(decimals)

  price = price.replace('.', decPoint)

  const splitNum = price.split(decPoint)
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsPoint)
  price = splitNum.join(decPoint)

  return price + 'đ'
}

export const setSameHeight = selector => {
  let maxHeight = 0
  // remove item height if isset
  selector.each((index, item) => {
    $(item).css('height', '')
  })
  // find max height
  selector.each((index, item) => {
    const itemOuterHeight = $(item).outerHeight()
    // console.log('itemHeight', itemOuterHeight)
    if (maxHeight < itemOuterHeight) maxHeight = itemOuterHeight
  })
  // console.log('maxHeight', maxHeight)
  // set height for each item
  selector.each((index, item) => {
    $(item).css('height', maxHeight + 'px')
  })
}
